<template>
    <!-- Modal -->
    <div class="modal fade" id="fetchAndAddFromHostBill" tabindex="-1" role="dialog" aria-labelledby="fetchAndAddFromHostBill" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">HostBill Accounts of Client: {{custID}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="loader" v-if="loadingHB"></div>
                    <!-- Section to show customer's Hosting Account details -->
                    <div class="cust-acc-details" v-else-if="!loadingHB && hbAccounts.length > 0" v-for="(account, index) in hbAccounts" :key="account.hbServiceID">
                        <button type="button" class="close text-red" aria-label="Close" @click.prevent="deleteItem(index, $event)">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <h5 class="text-center">Account Details for: {{ account.domain }}</h5>
                        <div class="row">
                            <label class="col-sm-2 col-md-2 col-lg-2 col-form-label">Server IP</label>
                            <div class="col-sm-10 col-md-2 col-lg-2">
                                <div class="form-group">
                                    <input type="text" class="form-control" :value="account.serverIP">
                                </div>
                            </div>
                            <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
                                <label class="col-sm-2 col-md-2 col-lg-2 col-form-label">Plan Name
                                    <strong class="text-danger">*</strong>
                                </label>
                            </transition>
                            <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
                                <div class="col-sm-10 col-md-2 col-lg-6">
                                    <div class="form-group">
                                        <select class="form-control" v-model="account.name">
                                            <option v-for="plan in plans" :value="plan.name" v-bind:key="plan.name"> {{ plan.name }}</option>
                                        </select>
                                    </div>
                                </div>
                            </transition>
                        </div>
                        <div class="row">
                            <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
                                <label class="col-sm-2 col-md-2 col-lg-2 col-form-label" v-if="account.type === 'Addon Domain'">Primary Domain Name
                                    <strong class="text-danger">*</strong>
                                    <i class="fa fa-question-circle ml-2 text-dark" data-toggle="tooltip" data-placement="top" title="Make sure you enter the domain name EXACTLY as mentioned in the domain name section of the primary domain. Simply copy paste it to be sure."></i>
                                </label>
                            </transition>
                            <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
                                <label class="col-sm-2 col-md-2 col-lg-2 col-form-label">Plan Limit
                                    <strong class="text-danger">*</strong>
                                </label>
                            </transition>
                            <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
                                <div class="col-sm-10 col-md-2 col-lg-2">
                                    <div class="form-group">
                                        <input type="number" class="form-control" required v-model.number="account.planLimit">
                                    </div>
                                </div>
                            </transition>
                            <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
                                <label class="col-sm-2 col-md-2 col-lg-2 col-form-label">Extra Sites
                                    <strong class="text-danger">*</strong>
                                </label>
                            </transition>
                            <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
                                <div class="col-sm-10 col-md-2 col-lg-2">
                                    <div class="form-group">
                                        <input type="number" class="form-control" required v-model.number="account.extraDomains">
                                    </div>
                                </div>
                            </transition>
                            <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
                                <label class="col-sm-2 col-md-2 col-lg-2 col-form-label">Max Storage Size (GB)
                                    <strong class="text-danger">*</strong>
                                </label>
                            </transition>
                            <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
                                <div class="col-sm-10 col-md-2 col-lg-2">
                                    <div class="form-group">
                                        <input type="number" class="form-control" required v-model.number="account.maxStorageSize">
                                    </div>
                                </div>
                            </transition>
                            <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
                                <label class="col-sm-2 col-md-2 col-lg-2 col-form-label">Max Visitors
                                    <strong class="text-danger">*</strong>
                                </label>
                            </transition>
                            <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
                                <div class="col-sm-10 col-md-2 col-lg-2">
                                    <div class="form-group">
                                        <input type="number" class="form-control" required v-model.number="account.maxVisitors">
                                    </div>
                                </div>
                            </transition>
                        </div>
                        <div class="row">
                            <label class="col-sm-2 col-md-2 col-lg-2 col-form-label">
                                Hostbill Service ID
                                <strong class="text-danger">*</strong>
                            </label>
                            <div class="col-sm-10 col-md-2 col-lg-2">
                                <div class="form-group">
                                    <input type="text" class="form-control" v-model="account.hbServiceID">
                                </div>
                            </div>
                            <label class="col-sm-2 col-md-2 col-lg-2 col-form-label">
                                SolusVM VPS ID
                                <strong class="text-danger">*</strong>
                            </label>
                            <div class="col-sm-10 col-md-2 col-lg-2">
                                <div class="form-group">
                                    <input type="text" class="form-control" v-model="account.solusVM_VPS_ID">
                                </div>
                            </div>
                            <label class="col-sm-2 col-md-2 col-lg-2 col-form-label">
                                Hostname
                                <strong class="text-danger">*</strong>
                            </label>
                            <div class="col-sm-10 col-md-2 col-lg-2">
                                <div class="form-group">
                                    <input type="text" class="form-control" v-model="account.hbHostname">
                                </div>
                            </div>

                        </div>
                        <hr class="color-line">
                    </div>
                    <!-- Section to show customer's Hosting Account details END -->
                    <div v-else>
                        <h4 class="text-danger">All host-bill plans are already added in WPO.</h4>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    <button type="button" class="btn btn-primary" :disabled="loadingHB" @click="addNewPlan()">
                        Add Accounts
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {db, functions} from "@/firebase/init";
    import swal from 'sweetalert2';
    export default {
        name: "FetchAndAddFromHostBill",
        data() {
            return {
                loadingHB: true,
                hbAccounts: [],
                allPlansAlreadyAdded: false
            }
        },
        computed: {
            hostingAccounts() {
                return this.$store.getters["hosting/accountsOrdered"];
            },
            hostingAccountObj() {
                return this.$store.getters["hosting/accounts"];
            },
            custID() {
                return this.$store.getters["customer/id"];
            },
            plans() {
                return this.$store.getters["plan/list"];
            },
            docID() {
                return this.$store.getters["customer/docID"];
            }
        },
        methods: {
            deleteItem(index) {
                if (confirm("Are you sure about deleting this item?")) {
                    this.hbAccounts = this.hbAccounts.filter(
                        (acc, currentIndex) => {
                            if (currentIndex !== index) {
                                return true;
                            }
                        }
                    );
                }
            },
            maxAddonDomainCountGenerator(planName) {
                let plan = this.plans.filter((item) => item.name === planName);
                if (plan.length) {
                    return plan[0].maxAddonDomain;
                }
                return 1;
            },
            diskSpaceGenerator(planName) {
                let plan = this.plans.filter((item) => item.name === planName);
                if (plan.length) {
                    return plan[0].maxStorageSize;
                }
                return 10;
            },
            visitorsGenerator(planName) {
                let plan = this.plans.filter((item) => item.name === planName);
                if (plan.length) {
                    return plan[0].visitors;
                }
                return 250000;
            },
            resetData() {
                this.loadingHB = true;
                this.hbAccounts = [];
                this.allPlansAlreadyAdded = true;
            },
            checkUndefined(data) {
                if (typeof data === "undefined" || data === null) {
                    return "";
                } else {
                    return data;
                }
            },
            load() {
                $("#fetchAndAddFromHostBill").modal('show');
                this.resetData();
                console.log(this.hostingAccounts);
                this.hbAccounts = [];
                // Now call the Firestore HTTP Cloud Function to get out details
                // const fetchHostBillData = functions.httpsCallable(
                //     "fetchHostBillClientDetails"
                // );
                // fetchHostBillData({
                //     clientID: this.custID
                // })
                this.$http.post("/host-bill/fetch-hostbill-client-details", {
                  clientId: this.custID,
                  grant_type: 'token',
                }).then(async response => {
                  console.log('response', response)
                    if (response.data.message) {
                        console.error(response.data.message);
                        swal('Error!', response.data.message, 'error');
                    } else {
                        for(const acc of response.data.custAccounts){
                            acc.serverIP = 'N/A';
                            if (acc.name !== "WPO Dedicated") {
                              let nodeInfoResp = {
                                data: {}
                              };
                              try{
                                nodeInfoResp = await this.$http.post('/solus-vm/fetch_node_info', {
                                  vmId: acc.extra_details.option6,
                                  grant_type: 'token'
                                });
                            } catch (e) {
                              nodeInfoResp = {
                                data: {}
                              }
                                nodeInfoResp.data.status = 'FAIL';
                                nodeInfoResp.data.message = 'Not In Solus-VM';
                              }

                              if(nodeInfoResp.data.status === 'success') {
                                acc.serverIP = nodeInfoResp.data.ipaddresses;
                              }else {
                                acc.serverIP = nodeInfoResp.data.message
                              }
                            }
                            if(this.isPlanExist(acc.serverIP)) {
                                this.allPlansAlreadyAdded = true;
                                continue;
                            }
                            this.allPlansAlreadyAdded = false;
                            acc.status = "pending";
                            acc.type = "Primary Domain";
                            acc.planLimit = this.planLimitCountGenerator(acc.name);
                            acc.extraDomains = 0;
                            acc.maxStorageSize = this.diskSpaceGenerator(acc.name);
                            acc.maxVisitors = this.visitorsGenerator(acc.name);
                            acc.hbServiceID = acc.id;
                            acc.hbHostname = acc.domain;
                            acc.solusVM_VPS_ID = acc.extra_details.option6;
                            this.hbAccounts.push(acc);
                        }
                    }
                }).catch(error => {
                    console.error(error);
                    swal('Error!', 'Error in fetching host bill account', 'error');
                }).finally(() => {
                    this.loadingHB = false;
                })
            },
            isPlanExist(ip) {
                let isPlanExist = false;
                this.hostingAccountObj.forEach(account => {
                    if (account.primary.serverIP === ip){
                        isPlanExist = true;
                    }
                });
                return isPlanExist;
            },
            async addNewPlan () {
                if(this.hbAccounts.length === 0) {
                    return swal('Already Synced!', 'All plans from host bill are already added in WPO', "warning");
                }
                this.loadingHB = true;
                const accountRef = await db.collection('hostingAccounts').doc(this.docID).get();
                const { accounts } = accountRef.data();
                const beforePayload = JSON.parse(JSON.stringify(accounts))
                this.hbAccounts.forEach(account => {
                    console.log(account);
                    if (account.type === "Primary Domain") {
                        accounts.push({
                            planName: account.name,
                            migration: {
                                count: 0,
                                log: []
                            },
                            primary: {
                                hbServiceID: this.checkUndefined(account.hbServiceID),
                                solusVM_VPS_ID: this.checkUndefined(account.solusVM_VPS_ID),
                                hbHostname: this.checkUndefined(account.hbHostname),
                                domain: '',
                                serverIP: this.checkUndefined(account.serverIP),
                                status: account.status,
                                comparisonID: this.checkUndefined(account.comparisonID),
                                flushOpcacheURL: this.checkUndefined(account.flushOpcacheURL),
                                freashInstall: false,
                                planType: 'standalone',
                                ftp: {
                                    host: this.checkUndefined(account.ftpHost),
                                    port: this.checkUndefined(account.ftpPort),
                                    mode: this.checkUndefined(account.ftpMode),
                                    pasv: this.checkUndefined(account.ftpPasv),
                                    username: this.checkUndefined(account.ftpUsername),
                                    password: this.checkUndefined(account.ftpPassword),
                                    accounts: [
                                        {
                                            username: this.checkUndefined(account.ftpUsername),
                                            password: this.checkUndefined(account.ftpPassword),
                                        }
                                    ]
                                },
                                phpMyAdmin: {
                                    url: this.checkUndefined(account.phpMyAdminURL),
                                    popupUsername: this.checkUndefined(
                                        account.phpMyAdminPopupUsername
                                    ),
                                    popupPassword: this.checkUndefined(
                                        account.phpMyAdminPopupPassword
                                    ),
                                    username: this.checkUndefined(account.phpMyAdminUsername),
                                    password: this.checkUndefined(account.phpMyAdminPassword)
                                },
                                cloudflare: {
                                    username: this.checkUndefined(account.cloudflareUsername),
                                    password: this.checkUndefined(account.cloudflarePassword),
                                    userKey: this.checkUndefined(account.cloudflareUserKey),
                                    apiKey: this.checkUndefined(account.cloudflareApiKey),
                                    zone_id: this.checkUndefined(account.cloudflareZoneId),
                                    nameserver1: this.checkUndefined(
                                        account.cloudflareNameserver1
                                    ),
                                    nameserver2: this.checkUndefined(
                                        account.cloudflareNameserver2
                                    )
                                },
                                staging: {
                                    enabled: false,
                                    domain: "",
                                    flushOpcacheURL: "",
                                    freashInstall: false,
                                    ftp: {
                                        host: "",
                                        port: "21",
                                        mode: "FTP (explicit SSL)",
                                        pasv: "Ensure is Checked/Enabled",
                                        username: "",
                                        password: "",
                                        accounts: [
                                            {
                                                username: "",
                                                password: "",
                                            }
                                        ]
                                    },
                                    phpMyAdmin: {
                                        url: "",
                                        popupUsername: "",
                                        popupPassword: "",
                                        username: "",
                                        password: ""
                                    }
                                }
                            },
                            planLimit: account.planLimit,
                            extraDomains: account.extraDomains,
                            maxStorageSize: account.maxStorageSize,
                            maxVisitors: account.maxVisitors,
                            uuid: '',
                            addon: []
                        });
                        this.addLog({
                          primaryPlan : 'Account Based Operation',
                          uid: this.docID,
                          message: 'New plan has been added in WPO!',
                          level: "info"
                        });
                    }
                });

                await this.addHostingAccountEventLog({hostingAccountId : this.docID ,  afterPayload: accounts , beforePayload : beforePayload, action: 'Fetch and Add Hostbill'})

                await db.collection('hostingAccounts').doc(this.docID).update({
                    accounts: accounts
                });
                $("#fetchAndAddFromHostBill").modal('hide');
                swal('Success!', 'All new plans have been added in wpo successfully. Log in to the user\'s account to create the first new primary domain.', 'success');
            }
        }
    }
</script>

<style scoped>
.modal-lg{
    max-width: 1020px !important;
}
</style>
